import { useEffect, useState } from 'react'
import api from '../../services/api'
import { Table, Container } from 'react-bootstrap'

import './styles.css'

import NavBar from '../../components/NavBar/NavBar'
import CorpoMon from '../../components/Mon/AlertBkp'
import MuiAlert from '@material-ui/lab/Alert'
import { Paper } from '@material-ui/core'

function Dashboard() {
  const idEmpresa = localStorage.getItem('idEmpresa')
  const [body, setBody] = useState([])
  const [status, setStatus] = useState('danger')
  function Alert(props) {
    return <MuiAlert elevation={3} variant="filled" {...props} />
  }

  useEffect(() => {
    ; (async () => {
      api.get('/backups/erros').then((response) => {
        const respost = response.data
        setBody(respost)
      })
    })()
  }, [])
  useEffect(() => {
    if (body[0]) {
      setStatus('success')
    }
  })
  return (
    <NavBar>
      <Container component={Paper} maxWidth='xl' >
        {body
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((body) => {
            return <CorpoMon key={body.id} data={body} />
          })}
        <br />
      </Container>

      {/*
                    <div className="table2">
                        <TableContainer component={Paper} elevation={5}>
                            <br />
                            <Alert
                                variant="filled"
                                severity="warning"
                                style={{ width: '50%', marginLeft: '25%' }}
                            >
                                Todas as empresas de avulsas
                            </Alert>
                            <br />
                            <Container>
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Empresa</th>
                                            <th>Squid</th>
                                            <th>Firewall</th>
                                            <th>Samba</th>
                                            <th>HTTP</th>
                                            <th>VPN</th>
                                            <th>Maquina</th>
                                            <th>Rede</th>
                                            <th>DHCP</th>
                                            <th>DNS</th>
                                            <th>MYSQL</th>
                                            <th>Backup</th>
                                            <th>Disco</th>
                                            <th>Memoria</th>
                                            <th>BKP</th>
                                            <th>LAST UPDATE</th>
                                            <th>IP</th>
                                        </tr>
                                    </thead>
                                    {body.map((urgente) => {
                                        return (
                                            <CorpoMon
                                                key={urgente.id}
                                                data={urgente}
                                            />
                                        )
                                    })}
                                    <br />
                                </Table>
                            </Container>
                        </TableContainer>
                    </div>
                */}
    </NavBar>
  )
}

export default Dashboard
